var render = function render(){var _vm=this,_c=_vm._self._c;return (Number(_vm.params.persona_id))?_c('v-container',{attrs:{"fluid":""}},[_c('v-tabs',{attrs:{"grow":""}},[_c('v-tabs-slider'),_c('v-tab',{attrs:{"href":`#tab_datos_personales`}},[_vm._v(" Datos Personales ")]),_c('v-tab-item',{attrs:{"value":'tab_datos_personales'}},[_c('Formulario',{attrs:{"getParams":this.params}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }